import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import af326d19256e72dfcd399041c409d1570b from "./generated-a29485d7-3582-4559-ae0e-fafae8dd7207.json";

import aaf4bc950b1b66b1ab335d844dc5709e1b from "./generated-eb62dfbe-912f-415e-aa07-16a07da89546.json";

import a772bfe2eeb6337dfcb0f6c21b8f03b08b from "./generated-5afb2c9d-5ad6-4583-8598-7ceabe335fe1.json";

import a3e719a44d022668064884aec22e09b88b from "./generated-f9fcc407-37c4-46bf-b6af-e0e969948c5a.json";

import ad83fe5daa4adfc1da653e911bb9e05e2b from "./generated-1c84c112-39b6-4ec7-8a87-4e79056d6cce.json";

import acd08786a39b3f355654e298414294bc7b from "./generated-1b2c60fa-04fa-4cc7-8855-46ca850ea8a6.json";

import a80a3f7ba7bfaeb3ef93fc641f7e3dfc5b from "./generated-75cf7ca6-036c-4267-b974-3ed8669ea119.json";

import a2a8ff4349d2b5f1946904439f1692755b from "./generated-d90672e1-ff0e-44ac-88f2-ebc6eb8b0f7d.json";

import acb7b02e44627827e6c4e9df5b7f19ef7b from "./generated-2053f20b-7853-4c6c-91f7-adc7d44caee0.json";

import abc6fd921e7eb1c8813f648c949a29927b from "./generated-bc3641df-e884-4d4e-951e-d30fcd96ae85.json";

import a84d903067c3c78942dfde6dee31750c9b from "./generated-5b2d312a-4f6f-4c60-9544-00cfeb3e77df.json";

import a5dc28e20d765b78fea6b3d801f64a42fb from "./generated-0f8b2297-be57-4106-8298-e28fa7f62fcd.json";

import a31f4716b7cc9bd82081473754414e359b from "./generated-8d37aae7-a49b-4fef-9aa1-385576ae2e7f.json";

import a538a894659941569558d989380951487b from "./generated-d0364f21-aaaf-42d7-8afb-8ca05274bbac.json";

import ab64ad378ea9330b5fada03eaca18699db from "./generated-41a8f57f-d313-4eff-9863-e1540981cb4b.json";

import a6ed72719d25b6ed6c5a69539cbe610d2b from "./generated-8878db3c-9ce0-4301-b340-f743ba239ae4.json";

import a4fdc34a329ed07476dc73761011a1519b from "./generated-759e98af-31a4-4a03-882f-23293f6783e7.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(af326d19256e72dfcd399041c409d1570b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(aaf4bc950b1b66b1ab335d844dc5709e1b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a772bfe2eeb6337dfcb0f6c21b8f03b08b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a3e719a44d022668064884aec22e09b88b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ad83fe5daa4adfc1da653e911bb9e05e2b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(acd08786a39b3f355654e298414294bc7b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a80a3f7ba7bfaeb3ef93fc641f7e3dfc5b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a2a8ff4349d2b5f1946904439f1692755b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(acb7b02e44627827e6c4e9df5b7f19ef7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(abc6fd921e7eb1c8813f648c949a29927b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a84d903067c3c78942dfde6dee31750c9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a5dc28e20d765b78fea6b3d801f64a42fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(acb7b02e44627827e6c4e9df5b7f19ef7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a31f4716b7cc9bd82081473754414e359b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a538a894659941569558d989380951487b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(acb7b02e44627827e6c4e9df5b7f19ef7b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ab64ad378ea9330b5fada03eaca18699db);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a6ed72719d25b6ed6c5a69539cbe610d2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a4fdc34a329ed07476dc73761011a1519b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ab64ad378ea9330b5fada03eaca18699db);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */